// ===============================
// Size button click (per product)
// ===============================
// NOTE: capture:true so we run BEFORE theme's bubbling listeners
document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('.complete-the-full-set-main .card-product__sizes-btn');
    if (!btn) return;

    const parentUl = btn.closest('ul');
    const card = btn.closest('card-product');
    if (!card) return;

    // 🔒 Stop default theme quick-add / other click handlers
    e.preventDefault();
    e.stopImmediatePropagation();

    // Keep sizes visible
    card.classList.add('is-active');

    // Optional: only one open at a time
    document
      .querySelectorAll('.complete-the-full-set-main card-product.is-active')
      .forEach(other => {
        if (other !== card) other.classList.remove('is-active');
      });

    // Handle active state on size buttons.
    // Unify .active (validation + mobile style) with .is-active (desktop selected-chip
    // style) so the selected size shows correctly on every viewport and the CTA/validation
    // read the same source of truth.
    if (parentUl) {
      parentUl
        .querySelectorAll('.card-product__sizes-btn')
        .forEach(el => el.classList.remove('active', 'is-active'));
      btn.classList.add('active', 'is-active');
    }

    // Update variant ID from clicked size
    let variantId = btn.dataset.variantid || btn.getAttribute('data-variantid');
    if (!variantId) {
      const sizeName = btn.dataset.size || btn.textContent.trim();
      try {
        const variants = JSON.parse(card.dataset.variants || '[]');
        const match = variants.find(v => v.options?.includes(sizeName));
        if (match) variantId = match.id;
      } catch (err) {
        console.warn('Could not parse variants for card', err);
      }
    }

    if (variantId) {
      card.dataset.selectedVariantId = variantId;
      const hiddenInput = card.querySelector('.js-selected-variant');
      if (hiddenInput) hiddenInput.value = variantId;
    }

    // Reflect the new selection on the set CTA (prompt -> ready once all sizes chosen)
    if (window.__ctsRefreshCta) window.__ctsRefreshCta();
  },
  true // 👈 capture phase
);



// =======================================
// Main Complete-the-set logic
// =======================================
document.addEventListener('DOMContentLoaded', function () {
  const setRootSelected = (root, variantId) => {
    if (!root || !variantId) return;
    root.dataset.selectedVariantId = String(variantId);
    const hidden = root.querySelector('.js-selected-variant');
    if (hidden) hidden.value = variantId;
  };

  const container = document.querySelector('[data-complete-the-set]');
  if (!container) return;

  // const priceWrap = container.querySelector('.complete-the-full-set-price-main');
  // const priceEl   = priceWrap?.querySelector('span');
  // const compareEl = priceWrap?.querySelector('s');

  const moneyFormat = (window?.theme?.moneyFormat) || '{{ amount_no_decimals_with_currency }}';
  const formatMoney = (cents) => {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  };

  const recalcTotals = () => {
    let total = 0, compare = 0;
    container.querySelectorAll('card-product').forEach(card => {
      let variants = [];
      try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (e) {}
      const id = Number(
        card.dataset.selectedVariantId ||
        card.querySelector('.js-selected-variant')?.value ||
        0
      );
      const v = variants.find(x => x.id === id) || variants[0];
      if (!v) return;
      total   += v.price || 0;
      compare += (v.compare_at_price && v.compare_at_price > v.price)
        ? v.compare_at_price
        : (v.price || 0);
    });
    //if (priceEl)   priceEl.textContent   = formatMoney(total);
    //if (compareEl) compareEl.textContent = compare ? formatMoney(compare) : '';
  };

  // Variant selection inside each card (for swatches / other variant UI)
  container.addEventListener('click', (e) => {
    const target = e.target.closest('.js-btn-size, .js-btn-swatch, [data-variantid]');
    if (!target) return;

    const card = e.target.closest('card-product');
    if (!card) return;

    let variantId = target.getAttribute('data-variantid');
    if (!variantId) {
      let variants = [];
      try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (e) {}

      const activeSizeBtn   = card.querySelector('.js-btn-size.is-active, .card-product__sizes-btn.active');
      const activeSwatchBtn = card.querySelector('.js-btn-swatch.is-active, input.js-btn-swatch:checked');

      const chosenSize  = activeSizeBtn?.dataset.size || activeSizeBtn?.textContent?.trim();
      const chosenColor = activeSwatchBtn?.value || activeSwatchBtn?.dataset.value || activeSwatchBtn?.textContent?.trim();

      const match = variants.find(v => {
        if (!v.options) return false;
        const opts = Array.isArray(v.options) ? v.options : Object.values(v.options || {});
        const sizeOK  = !chosenSize  || opts.includes(chosenSize);
        const colorOK = !chosenColor || opts.includes(chosenColor);
        return sizeOK && colorOK;
      });

      if (match) variantId = match.id;
    }

    if (variantId) {
      setRootSelected(card, variantId);
      //setTimeout(recalcTotals, 0);
    }
  });

  const addAllBtn  = container.querySelector('.complete-the-full-main-cart');
  const cartDrawer = document.querySelector('cart-drawer');

  // ---- Dropdown size selection (2026-07-12 · McKenzie) ----
  // Each set card now carries a .js-cts-size <select> (option value = variant id). Selection
  // writes the same state the chip flow wrote (dataset.selectedVariantId + .js-selected-variant),
  // so collectItems/add-all work unchanged.
  container.addEventListener('change', (e) => {
    const sel = e.target.closest && e.target.closest('.js-cts-size');
    if (!sel) return;
    const card = sel.closest('card-product');
    if (!card) return;
    if (sel.value) {
      setRootSelected(card, sel.value);
      card.classList.remove('missing-variant');
    }
    if (window.__ctsRefreshCta) window.__ctsRefreshCta();
  });

  // ---- Set CTA label · prompt until every sized card has a selection (2026-07-09) ----
  // Sizes now start unselected; the button reads its prompt label ("Select your sizes")
  // and flips to the ready label ("Complete the Collection") only once every size-optioned
  // card in the set has a chosen size. Labels come from data-* on the button (editable in Liquid).
  const ctaPromptLabel = (addAllBtn && addAllBtn.dataset.promptLabel) || 'Select your sizes';
  const ctaReadyLabel  = (addAllBtn && addAllBtn.dataset.readyLabel)  || (addAllBtn && addAllBtn.textContent.trim()) || 'Complete the Collection';
  // 2026-07-12 · cards now carry a .js-cts-size dropdown (chips remain in DOM but hidden);
  // the select is the source of truth when present, chip active-state stays as the fallback.
  const allSizesChosen = () => {
    let ok = true;
    container.querySelectorAll('card-product').forEach(card => {
      const sel = card.querySelector('.js-cts-size');
      if (sel) {
        if (!sel.value) ok = false;
        return;
      }
      if (card.querySelectorAll('.card-product__sizes-btn').length > 0 &&
          !card.querySelector('.card-product__sizes-btn.is-active, .card-product__sizes-btn.active')) {
        ok = false;
      }
    });
    return ok;
  };
  const refreshSetCta = () => {
    if (!addAllBtn) return;
    addAllBtn.textContent = allSizesChosen() ? ctaReadyLabel : ctaPromptLabel;
  };
  window.__ctsRefreshCta = refreshSetCta;
  refreshSetCta();

  // Collect items → ONE LINE PER VARIANT ID, quantity always 1
  const collectItems = () => {
    const map = new Map();

    container.querySelectorAll('card-product').forEach(card => {
      const vid = Number(
        card.dataset.selectedVariantId ||
        card.querySelector('.js-selected-variant')?.value ||
        0
      );
      if (vid > 0 && !map.has(vid)) {
        map.set(vid, { id: vid, quantity: 1 });
      }
    });

    return Array.from(map.values());
  };

  // Validate selections: select-first (2026-07-12 dropdown conversion), chip active-state as fallback
  const validateSelections = () => {
    let allGood = true;

    container.querySelectorAll('card-product').forEach(card => {
      const sel = card.querySelector('.js-cts-size');
      if (sel) {
        if (!sel.value) {
          allGood = false;
          card.classList.add('missing-variant');
        } else {
          card.classList.remove('missing-variant');
        }
        return;
      }
      const sizeButtons = card.querySelectorAll('.card-product__sizes-btn');

      if (sizeButtons.length > 0) {
        const activeSize = card.querySelector('.card-product__sizes-btn.active');
        if (!activeSize) {
          allGood = false;
          card.classList.add('missing-variant');
        } else {
          card.classList.remove('missing-variant');
        }
      }
    });

    return allGood;
  };

  const addItemsWithDrawer = async (items) => {
    if (!items.length) return;

    const fd = new FormData();
    items.forEach((it, i) => {
      fd.append(`items[${i}][id]`, it.id);
      fd.append(`items[${i}][quantity]`, 1); // 👈 hard-force quantity 1
    });

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map(s => s.section);
      fd.append('sections', sections);
      fd.append('sections_url', window.location.pathname);
    }

    const url = window.routes?.cart_add_url || '/cart/add';
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: fd,
      credentials: 'same-origin'
    };

    const res = await fetch(url, config);
    const ct  = res.headers.get('content-type') || '';
    let data  = null;

    if (ct.includes('application/json')) {
      data = await res.json();
    } else {
      await res.text();
    }

    if (data?.status) {
      alert(data.description || 'Some items could not be added.');
    } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.classList.add('is-open', 'active', 'open');
      }
    } else {
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: data || {} }));
    }
  };

  if (addAllBtn) {
    // 🧷 Make sure we only bind this handler ONCE
    if (!addAllBtn.dataset.ctsBound) {
      addAllBtn.dataset.ctsBound = 'true';

      addAllBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        
        // 🌐 global guard in case script is included twice
        if (window.__completeTheSetBusy) return;

        // Block if already busy
        if (addAllBtn.classList.contains('is-busy') || addAllBtn.hasAttribute('disabled')) {
          return;
        }

        if (!validateSelections()) {
          alert('Hover over the products and select your size');
          return;
        }

        const items = collectItems();
        if (!items.length) {
          alert('Hover over the products and select your size');
          return;
        }

        // Lock
        window.__completeTheSetBusy = true;
        addAllBtn.classList.add('is-busy', 'disabled');
        addAllBtn.setAttribute('disabled', 'disabled');

        try {
          await addItemsWithDrawer(items);
        } catch (err) {
          console.error('Add all failed', err);
          alert('Sorry, something went wrong adding the set.');
        } finally {
          setTimeout(() => {
            window.__completeTheSetBusy = false;
            addAllBtn.classList.remove('is-busy', 'disabled');
            addAllBtn.removeAttribute('disabled');
          }, 1200);
        }
      });
    }
  }

  // Initial total
  //recalcTotals();
});




/* BHL 2026-07-12 · Unselected-size buy box (cro- PDPs only · McKenzie).
   Liquid (main-product-cro.liquid cro_unselected_load) renders clean loads with no checked
   size, an empty variant id, and a disabled "Select Your Size" button. This block flips the
   button to the real label (data-atc-label, e.g. "Add to Bag · $158") on the first size pick.
   Two theme behaviors make the details here load-bearing:
   · product-form.js caches the button's INITIAL text as defaultButtonLabel at construction
     and restores that cache on every toggleAddButton(false,…) — so the cache must be
     re-pointed at the ready label or the button snaps back to the prompt on later picks.
   · product-selector.js replaceWith()-swaps the whole <product-selector> after each pick,
     so the listener is delegated to document (survives the swap); the swapped-in render
     arrives already checked with the legend filled (?option_values= → selected_value). */
(function () {
  var form = document.querySelector('product-form[data-unselected-load]');
  if (!form) return;
  var ready = form.getAttribute('data-atc-label');
  if (!ready) return;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('product-selector input[type="radio"]')) return;
    var btn = form.querySelector('.product-selector__submit');
    if (btn) {
      btn.textContent = ready;
      btn.removeAttribute('disabled');
    }
    form.defaultButtonLabel = ready;
    /* fill the SIZE legend immediately (the server-rendered swap lands ~300ms later with
       the same value; this just removes the blink) */
    var em = document.querySelector('product-selector .product-selector__label em');
    if (em && t.value) em.textContent = t.value;
  });
  /* Prompt-state click guard: theme init strips the liquid-rendered disabled attribute
     (probe 2026-07-12), so an unpicked "Select Your Size" tap must not submit the form
     (empty variant id → cart error). Mirror the sticky bar's pre-select behavior instead:
     scroll the size options into view. Once any size is checked this guard stands down. */
  form.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-selector__submit');
    if (!btn) return;
    if (document.querySelector('product-selector input[type="radio"]:checked')) return;
    e.preventDefault();
    e.stopPropagation();
    var target = document.querySelector('#product-option--size') || document.querySelector('product-selector');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
})();

// BHL 2026-07-12 · Genie discount-field resilience (McKenzie: "doesn't always render").
// The dg_code app re-injects its box by observing cart requests (PerformanceObserver ·
// window.__dg_cartPerfObserver). On some devices a drawer re-render lands before/without the
// observer firing and the field never comes back. Watch the persistent <cart-drawer> element:
// when a render settles with the drawer open, items present, and no dg_code block, issue one
// lightweight /cart.js read — a resource entry the app's observer catches, prompting it to
// re-inject. Capped at 3 consecutive nudges so an uninstalled app can't cause a fetch loop.
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || !('MutationObserver' in window)) return;
  var timer;
  var nudges = 0;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!drawer.classList.contains('is-visible')) return;
      var body = document.querySelector('#CartDrawer-Body');
      if (!body || body.querySelector('.cart-drawer__empty')) return;
      if (body.querySelector('[class*="dg_code"]')) { nudges = 0; return; }
      if (nudges >= 3) return;
      nudges += 1;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).catch(function () {});
    }, 1200);
  }).observe(drawer, { childList: true, subtree: true });
})();

// BHL 2026-07-12 · scroll-reveal for the PDP editorial descent (McKenzie: "infinite scroll
// style animations without slowing it down"). Perf-safe by construction: IntersectionObserver
// only (no scroll listeners), opacity/transform only (compositor · no layout, no CLS), each
// target unobserved after firing, elements already in view at init reveal instantly (no pop),
// reduced-motion users and no-JS sessions see everything exactly as before.
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!document.body.className.match(/template--cro-/)) return;
  var targets = document.querySelectorAll(
    '.pdp-fit .pdp-inner, .pdp-silk .pdp-inner, .pdp-pairs .pdp-inner, .pdp-lovies .pdp-inner, .pdp-reco .pdp-inner, .pdp-close-band__in, .main-product__tabs-wrapper, .complete-the-full-set-main-sec'
  );
  if (!targets.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (t) {
    var inView = t.getBoundingClientRect().top < window.innerHeight * 0.92;
    if (inView) t.classList.add('is-revealed');
    t.classList.add('js-reveal');
    if (!inView) io.observe(t);
  });
})();

// BHL 2026-07-12 · CTS rail: swipes that START on a size dropdown now pan the carousel
// (McKenzie: "slide this section by swiping the text too"). The rail is native overflow +
// scroll-snap, which pans from text/images already — but iOS gives horizontal touches on a
// native <select> to the picker, so the dropdown row was a dead zone. Shim: >10px of
// horizontal intent scrolls the rail manually and one-shot-blocks the picker click; a plain
// tap still opens the select. Touch-only, no scroll-perf cost when idle.
(function () {
  var rail = document.querySelector('.complete-the-full-set-main');
  if (!rail) return;
  var startX = 0, startY = 0, startLeft = 0, dragging = false, activeSel = null;
  rail.addEventListener('touchstart', function (e) {
    var sel = e.target.closest && e.target.closest('select');
    if (!sel) return;
    activeSel = sel;
    dragging = false;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    startLeft = rail.scrollLeft;
  }, { passive: true });
  rail.addEventListener('touchmove', function (e) {
    if (!activeSel) return;
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;
    if (!dragging && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) dragging = true;
    if (dragging) {
      e.preventDefault();
      rail.scrollLeft = startLeft - dx;
    }
  }, { passive: false });
  rail.addEventListener('touchend', function () {
    if (dragging && activeSel) {
      var sel = activeSel;
      var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      sel.addEventListener('click', block, { capture: true, once: true });
      setTimeout(function () { sel.removeEventListener('click', block, { capture: true }); }, 400);
      var slides = [].slice.call(rail.querySelectorAll('.card-product-slider__slide-main'));
      if (slides.length) {
        var nearest = slides.reduce(function (best, s) {
          return Math.abs(rail.scrollLeft - s.offsetLeft) < Math.abs(rail.scrollLeft - best.offsetLeft) ? s : best;
        }, slides[0]);
        rail.scrollTo({ left: nearest.offsetLeft, behavior: 'smooth' });
      }
    }
    dragging = false;
    activeSel = null;
  }, { passive: true });
})();

// BHL 2026-07-12 · spec tabs: swipe the PANEL TEXT to move between tabs (McKenzie). Touch-only
// and fully passive (we never preventDefault, so vertical page scroll is untouched · we just
// read the gesture on touchend). A clear horizontal swipe (>=48px, dominant axis) clicks the
// neighboring tab button — the theme's own openTab keeps every state transition — and the tab
// row centers the new active label. No wraparound at either end.
(function () {
  document.querySelectorAll('.main-product__tabs-wrapper').forEach(function (wrap) {
    var buttons = [].slice.call(wrap.querySelectorAll('.main-product__tab'));
    var panels = [].slice.call(wrap.querySelectorAll('.main-product__tab-content'));
    if (buttons.length < 2 || buttons.length !== panels.length) return;
    var sx = 0, sy = 0, tracking = false;
    wrap.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.main-product__tab-content')) return;
      tracking = true;
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
      var current = -1;
      for (var i = 0; i < panels.length; i++) {
        if (getComputedStyle(panels[i]).display !== 'none') { current = i; break; }
      }
      var next = current + (dx < 0 ? 1 : -1);
      if (current < 0 || next < 0 || next >= buttons.length) return;
      buttons[next].click();
      // Center the active label by scrolling ONLY the tab row. scrollIntoView(inline:'center')
      // was the 2026-07-12 buy-box-shift bug: it may scroll every scrollable ancestor, and
      // centering the longest label (SHIPPING & RETURNS) overflowed the row's range and
      // horizontally shifted the buy-box container itself.
      var row = wrap.querySelector('.main-product__tabs');
      if (row) {
        var b = buttons[next];
        var target = b.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - (row.clientWidth - b.offsetWidth) / 2;
        row.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      }
    }, { passive: true });
  });
})();

// BHL 2026-07-12 · desktop rail arrows for Complete the look / Also in [colorway] (the
// grids became one-row scroll rails). One delegated listener; each click scrolls its own
// rail by exactly one card. Hidden on mobile where swipe owns the gesture.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-rail-prev], [data-rail-next]');
  if (!btn) return;
  var inner = btn.closest('.pdp-inner');
  var rail = inner && inner.querySelector('[data-rail]');
  if (!rail) return;
  var card = rail.querySelector('.pdp-reco__card');
  var step = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * 0.28;
  rail.scrollBy({ left: btn.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
});

// BHL 2026-07-21 · McKenzie: PDP carousels ("Complete the Look" / "Also in") adopt the
// Designed to Be Collected gold progress slider + end-aware arrows. One init per
// [data-rail] that has a sibling .pdp-rail__progress in its .pdp-inner. Mirrors the
// self-contained progress logic in bhl-collection-edit.liquid.
(function () {
  function initRail(rail) {
    var inner = rail.closest('.pdp-inner');
    if (!inner) return;
    var track = inner.querySelector('.pdp-rail__progress');
    var thumb = inner.querySelector('.pdp-rail__progress-thumb');
    var prev = inner.querySelector('[data-rail-prev]');
    var next = inner.querySelector('[data-rail-next]');
    function update() {
      var scrollable = rail.scrollWidth > rail.clientWidth + 4;
      if (track) track.hidden = !scrollable;
      if (scrollable && thumb) {
        var share = rail.clientWidth / rail.scrollWidth * 100;
        var pos = rail.scrollLeft / rail.scrollWidth * 100;
        thumb.style.width = share + '%';
        thumb.style.left = Math.min(pos, 100 - share) + '%';
      }
      var max = rail.scrollWidth - rail.clientWidth - 2;
      var atStart = rail.scrollLeft <= 2, atEnd = rail.scrollLeft >= max;
      if (prev) { prev.style.opacity = atStart ? '.3' : '1'; prev.style.pointerEvents = atStart ? 'none' : 'auto'; }
      if (next) { next.style.opacity = atEnd ? '.3' : '1'; next.style.pointerEvents = atEnd ? 'none' : 'auto'; }
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() {
    document.querySelectorAll('.pdp-inner [data-rail]').forEach(function (rail) {
      if (rail.closest('.pdp-inner').querySelector('.pdp-rail__progress')) initRail(rail);
    });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

/* 2026-07-12 · McKenzie: CONTINUOUS two-finger trackpad scroll on the desktop thumbnail rail
   (replaces the earlier step:1 discrete stepper · he wanted smooth panning, not one-thumb jumps).
   The rail is a MagicScroll transform carousel. (1) Disable its loop so the strip is a clean linear
   row (updateOptions loop:false · confirmed 15 clones → 7 real, strip 2400 → 1120px, no duplicates).
   (2) Drive the strip transform ourselves on HORIZONTAL wheel: track a clamped position in
   [-(scrollWidth - viewport), 0] and set translateX · a short ease makes it glide continuously with
   the trackpad. Vertical wheel passes through so the page still scrolls. Pager buttons still work
   (each new gesture re-syncs position from the live transform). Native overflow scroll was NOT an
   option here · the .mcs-item thumbs are absolutely positioned, so an overflow container stays 0-wide.
   Desktop only; async-retry bind (MagicScroll builds late). */
(function () {
  function bind() {
    var rail = document.querySelector('.MagicScroll');
    if (!rail || rail.__bhlContScroll) return true;
    var MS = window.MagicScroll;
    if (!MS || typeof MS.getInstance !== 'function') return false;
    var inst = MS.getInstance(rail.id) || MS.getInstance(rail);
    if (!inst || typeof inst.updateOptions !== 'function') return false;
    var strip = rail.querySelector('.mcs-items-container');
    if (!strip) return false;
    rail.__bhlContScroll = true;
    try { inst.updateOptions({ loop: false }); } catch (e) {}
    strip.style.transition = 'transform 0.08s ease-out';
    var viewport = strip.parentElement;
    var pos = 0, lastWheel = 0;
    rail.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical → let the page scroll
      e.preventDefault();
      var now = Date.now();
      if (now - lastWheel > 150) {                          // new gesture → resync (covers pager clicks)
        pos = new DOMMatrix(getComputedStyle(strip).transform).m41;
      }
      lastWheel = now;
      var maxScroll = Math.max(0, strip.scrollWidth - viewport.clientWidth);
      pos = Math.max(-maxScroll, Math.min(0, pos - e.deltaX));
      strip.style.transform = 'translateX(' + pos + 'px)';
    }, { passive: false });
    return true;
  }
  if (!bind()) {
    var t = 0, iv = setInterval(function () { if (bind() || ++t > 30) clearInterval(iv); }, 400);
  }
})();

/* 2026-07-12 · McKenzie: inject a REAL inline SVG chevron into the Magic Zoom photo arrows.
   CSS-drawn icons (data-URI, border-box, font glyph) do not render reliably/consistently on these
   anchors · a real <svg> node always does, identically across browsers, at the exact size CSS sets
   (.bhl-arrow-svg in new-dev.css). We only ADD the icon; the anchor's own click still drives nav.
   Idempotent, async-retry (Magic Zoom builds late), and re-injects via a MutationObserver in case
   the app rebuilds the gallery on a variant swap or resize. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function makeSvg(isPrev) {
    var s = document.createElementNS(NS, 'svg');
    s.setAttribute('class', 'bhl-arrow-svg');
    s.setAttribute('viewBox', '0 0 24 44');
    s.setAttribute('fill', 'none');
    s.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', isPrev ? 'M17 4 L7 22 L17 40' : 'M7 4 L17 22 L7 40');
    path.setAttribute('stroke', '#ffffff');
    path.setAttribute('stroke-width', '2.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    s.appendChild(path);
    return s;
  }
  function inject() {
    var arrows = document.querySelectorAll('.MagicToolboxSlides a.MagicToolboxSlides-arrow');
    if (!arrows.length) return false;
    arrows.forEach(function (a) {
      if (a.querySelector('.bhl-arrow-svg')) return;
      a.appendChild(makeSvg(a.classList.contains('magic-prev')));
    });
    return true;
  }
  if (!inject()) {
    var t = 0, iv = setInterval(function () { if (inject() || ++t > 30) clearInterval(iv); }, 400);
  }
  window.addEventListener('resize', inject);
  try {
    var host = document.querySelector('.MagicToolboxContainer') || document.body;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; inject(); });
    }).observe(host, { childList: true, subtree: true });
  } catch (e) {}
})();


/* 2026-07-22 P1 a11y · the PDP thumbnail scroller's prev/next arrows are injected by
   the MagicScroll app as EMPTY <button> elements (no accessible name · axe critical).
   The app's DOM isn't theme-editable, so label it from the theme layer: idempotent,
   observer-armed (the app injects after load and can re-render). Theme-side only ·
   no app configuration is touched. */
(function () {
  function labelMscArrows(root) {
    (root || document).querySelectorAll('.mcs-button-arrow-prev:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Previous product images');
    });
    (root || document).querySelectorAll('.mcs-button-arrow-next:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Next product images');
    });
  }
  function arm() {
    labelMscArrows(document);
    var host = document.getElementById('msc-selectors-container') || document.body;
    var mo = new MutationObserver(function () { labelMscArrows(document); });
    mo.observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
